import { formatDate } from '@/features/common/formatDate';
import { removableMember } from '@/features/publicsite/community/spaceRoster';
import type { SpaceMembersProps } from '@/features/publicsite/types/community/SpaceMembersProps';
import { publicCommunity } from '@/i18n/dictionaries/publicCommunity';
import { useTranslation } from '@/i18n/useTranslation';

/**
 * A private space's roster as the server orders it, owner first: each member by name, the owner
 * tagged, and when they joined — nothing for a membership older than the date was kept. The owner
 * has a "Scoate" button on every other row.
 */
export function SpaceMembers({ members, actions, userId, onRemove }: SpaceMembersProps) {
  const { t, language } = useTranslation(publicCommunity);
  return (
    <ul className="space-members">
      {members.map((member) => (
        <li key={member.userId} className="space-members__row">
          <span className="space-members__who">
            <span className="space-members__name">{member.fullName}</span>
            {member.owner && <span className="tag tag--info">{t('ownerTag')}</span>}
            {member.joinedAt && (
              <span className="space-members__since">
                {t('memberSince', { date: formatDate(member.joinedAt, language) })}
              </span>
            )}
          </span>
          {removableMember(member, actions, userId) && (
            <button
              type="button"
              className="btn btn--ghost"
              aria-label={t('removeMemberAria', { name: member.fullName })}
              onClick={() => onRemove(member)}
            >
              {t('removeMember')}
            </button>
          )}
        </li>
      ))}
    </ul>
  );
}
